import React, { useEffect, useState } from 'react';


import logo_white from '../../assets/images/logo_white.svg'
import mwaliLogo from '../../assets/images/Mwali_security_logo.png'



import cl from './Footer.module.css'
import { NavLink, useLocation } from 'react-router-dom';
import tgIcon from "../../assets/icons/tgIcon.svg";
import whatsAppIcon from "../../assets/icons/whatsAppForContact.svg";
import linkedIcon from "../../assets/icons/linkedinIcon.svg";
import scheduleIcon from '../../assets/icons/calendarIcon.svg'


const Footer = () => {

    
    const [hideFooter, setHideFooter] = useState(false)

    // const urlsArray = ['/login', '/sign-up', '/personal-account']
    
    const location = useLocation();

    useEffect(() => {
       
        if (window.location.pathname.includes('/login')
            || window.location.pathname.includes('/sign-up')
            || window.location.pathname.includes('/personal_account')
        ) {
            setHideFooter(true)
        } else {
            setHideFooter(false)
        }
    }, [window.location.pathname])
    return hideFooter ? null : (
        
        <div className={cl.footer_container}>
                <div className={cl.left_side_footer}>
                    <div className={cl.upper_footer_content}>
                        <img src={logo_white} alt="#footer_logo" />
                        
                    </div>
                    <p className={cl.footer_descr}>
                        Fortres BanCorp is licensed by the Mwali International Services Authority (M.I.S.A.) to provide regulated financial and payment services in accordance with its applicable licensing framework.
                        <br/><br/>
                        This can be confirmed through the Mwali International Services Authority (M.I.S.A.). Fortres BanCorp may also provide these services in conjunction with other M.I.S.A.-licensed or exempt partners.
                    </p>
                    {/* <div className={cl.socials_img_wrapper}>
                        <div className={cl.img_wrapper}>
                            <img src={facebook} alt="#facebook" />
                        </div>
                         <div className={cl.img_wrapper}>
                            <img src={inst} alt="#facebook" />
                        </div>
                         <div className={cl.img_wrapper}>
                            <img src={youtube} alt="#facebook" />
                        </div>
                         <div className={cl.img_wrapper}>
                            <img src={twitter} alt="#facebook" />
                        </div>
                    </div> */}
                </div>
                <div className={cl.right_side_footer}>
                    <div className={cl.links_footer_row_wrapper}>
                        <div className={cl.column_row_items}>
                            <div className={cl.first_item}>
                                Support
                            </div>
                            
                            <NavLink to='/services'>
                                <div className={cl.second_item}>
                                    Services
                                </div>
                            </NavLink>
                            <NavLink to='/contact-us'>
                            <div className={cl.second_item}>
                                Contact Us
                            </div>
                            </NavLink>
                        </div>
                         <div className={cl.column_row_items}>
                            
                            <div className={cl.first_item}>
                                Company
                            </div>
                            <NavLink to='/personal'>
                            <div className={cl.second_item}>
                                Personal
                            </div>
                            </NavLink>
                            <NavLink to='/about-us'>
                            <div className={cl.second_item}>
                                About Us
                            </div>
                            </NavLink>
                            

                        </div>
                        <div className={cl.column_row_items}>
                            <div className={cl.first_item}>
                                Reach us
                            </div>

                                <div className={cl.second_item}>
                                    <a href="https://t.me/+420775497164">
                                        <img src={tgIcon} alt="Telegram"/>
                                    </a>
                                </div>
                                <div className={cl.second_item}>
                                    <a href="https://wa.me/447846774768">
                                        <img src={whatsAppIcon} alt=""/>
                                    </a>
                                </div>
                                <div className={cl.second_item}>
                                    <a href="https://www.linkedin.com/company/fortres-bancorp/">
                                        <img src={linkedIcon} alt=""/>
                                    </a>
                                </div>
                            <div className={cl.second_item}>
                                <a href="https://calendly.com/fortres-sales/fortres-bancorp-meeting">
                                    <img src={scheduleIcon} alt=""/>
                                </a>
                            </div>



                        </div>
                         <div className={cl.column_row_items}>
                            <div className={cl.first_item}>
                                Legal
                            </div>
                            <NavLink to='/terms'>
                            <div className={cl.second_item}>
                                Privacy & Terms
                            </div>
                            </NavLink>
                            
                        </div>
                        <div className={cl.column_row_items}>
                            <div className={cl.first_item}>
                                License Number
                            </div>
                            <div className={cl.mwali_image_wrapper}>
                                <img src={mwaliLogo} alt=""/>
                            </div>
                            <h3 className={cl.mwali_number}>B2026134</h3>
                            <a href='https://mwaliregistrar.com/list_of_entities/verify/581'>
                                <div className={[cl.second_item, cl.footer_mwali_link].join(' ')}>
                                    Link to license
                                </div>
                            </a>

                        </div>
                    </div>
                </div>
            </div>
    );
};

export default Footer;